import { mergeInterruptedThread } from './mergeInterruptedThread'
import { shouldReplaceWithServerMessages } from './shouldReplaceWithServerMessages'

export function applyFetchedThreadMessages(prev, id, messages, unresolved) {
  if (!messages.length) return prev
  if (unresolved) {
    const merged = mergeInterruptedThread(prev[id] ?? [], messages)
    return merged === prev[id] ? prev : { ...prev, [id]: merged }
  }
  return shouldReplaceWithServerMessages(prev[id] ?? [], messages)
    ? { ...prev, [id]: messages }
    : prev
}
